import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import DOMPurify from "dompurify";
import { api } from "../api/client";

export function RubriqueBlock({ cle }) {
  const [rub, setRub] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/rubriques/${cle}`).then(setRub).catch(() => setMissing(true));
  }, [cle]);

  if (missing) return null;
  if (!rub) return <p className="muted">Chargement…</p>;

  return (
    <section className="mb-3">
      <h2>{rub.titre}</h2>
      <div className="article-content"
           dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(rub.contenu_html || "") }} />
    </section>
  );
}

export default function Rubrique() {
  const { cle } = useParams();
  const [rub, setRub] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/rubriques/${cle}`)
      .then(setRub)
      .catch(() => setError("Cette page est introuvable."));
  }, [cle]);

  if (error) return <div className="container"><div className="error">{error}</div></div>;
  if (!rub) return <div className="container"><p className="muted">Chargement…</p></div>;

  const isSalle = cle === "salle-des-fetes";

  return (
    <div className="container">
      <h1>{rub.titre}</h1>
      <div className="article-content mt-2"
           dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(rub.contenu_html || "") }} />

      {isSalle && (
        <div className="rubrique-cta">
          <Link to="/reserver-salle" className="rubrique-cta-btn">
            📅 Pré-réserver la salle
          </Link>
          <p className="muted" style={{ fontSize: "0.85em", marginTop: "0.6rem" }}>
            Choisissez vos dates en ligne. La mairie validera votre demande
            après vérification de la disponibilité.
          </p>
        </div>
      )}
    </div>
  );
}
